import axiosAgent from './axiosAgent';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ApiConfig from '../config/ApiConfig';

export const createSubCategory = async (formData, majorId, setOpen) => {
    const response = await axiosAgent.post(
        `${ApiConfig.subCategory.createCategory}/${majorId}`,
        formData,
    );

    console.log('Sub category Created', response.data);
    if (response.data.success) {
        toast.success('Sub category Created successfully');
    }
    setOpen(false);
    return response.data.data;
};

export const getSubCategoriesById = async (majorId) => {
    const response = await axiosAgent.get(
        `${ApiConfig.subCategory.getSubCategoriesById}/${majorId}`,
    );
    console.log('Subcats Fetched', response.data);
    return response.data.data;
};
export const deleteSubCategoryById = async (id) => {
    const response = await axiosAgent.delete(
        `${ApiConfig.subCategory.deleteSubCategory}/${id}`,
    );
    console.log('Subcats Fetched', response.data);
    return response.data.data;
};
export const editSubCategoryById = async (id, values) => {
    const response = await axiosAgent.put(
        `${ApiConfig.subCategory.editSubCategory}/${id}`,
        values,
    );
    return response;
};
export const getAllCategories = async () => {
    const response = await axiosAgent.get(ApiConfig.category.getAllCategories);
    console.log('response', response.data.data);
    return response.data.data;
};
export const deleteCategoryById = async (id) => {
    const response = await axiosAgent.delete(
        `${ApiConfig.category.deleteCategory}/${id}`,
    );
    console.log('Subcats Fetched', response.data);
    return response.data.data;
};
export const editCategoryById = async (id, values) => {
    const response = await axiosAgent.put(
        `${ApiConfig.category.editCategory}/${id}`,
        values,
    );
    return response;
};
export const createCategory = async (values) => {
    const response = await axiosAgent.post(
        ApiConfig.category.createCategory,
        values,
    );
    return response;
};
